import f from "../../@babel/runtime/helpers/esm/extends2.mjs";
import m from "../../@babel/runtime/helpers/esm/objectWithoutProperties2.mjs";
import * as e from "react";
import d from "../../classnames/index2.mjs";
import u from "./Item.mjs";
import { OverflowContext as s } from "./Overflow.mjs";
var N = ["component"], w = ["className"], x = ["className"], C = function(r, o) {
  var a = e.useContext(s);
  if (!a) {
    var t = r.component, l = t === void 0 ? "div" : t, n = m(r, N);
    return /* @__PURE__ */ e.createElement(l, f({}, n, {
      ref: o
    }));
  }
  var i = a.className, p = m(a, w), c = r.className, v = m(r, x);
  return /* @__PURE__ */ e.createElement(s.Provider, {
    value: null
  }, /* @__PURE__ */ e.createElement(u, f({
    ref: o,
    className: d(i, c)
  }, p, v)));
}, E = /* @__PURE__ */ e.forwardRef(C);
E.displayName = "RawItem";
export {
  E as default
};
//# sourceMappingURL=RawItem.mjs.map
